import DealType from '../Models/DealType';
import DataGridRequest from './DataGridRequest';

export class DealLinksRequest extends DataGridRequest<DealType> {
    Url = 'api/v1/deals/deal_links';
}
